import React from "react"
import { Button, CircularProgress, makeStyles, Theme } from "@material-ui/core"
import { useAuth } from "./AuthProvider"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles((theme: Theme) => ({
  loading: {
    color: theme.palette.common.white,
  },
}))

export const AuthButton: React.FC = () => {
  /** Get auth tooling from auth */
  const { status, requestAuthChange } = useAuth()

  /** Get scoped CSS classes */
  const classes = useStyles()

  return status === "loading" ? (
    <CircularProgress className={classes.loading} size={24} />
  ) : (
    <Button
      color="secondary"
      onClick={() =>
        requestAuthChange(status === "signedIn" ? "signOut" : "signIn")
      }
    >
      Sign {status === "signedIn" ? "out" : "in"}
    </Button>
  )
}
